import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from './toast.service';

let isRedirecting = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const toastService = inject(ToastService);
    const token = localStorage.getItem('token');

    // Attach token
    if (token) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(req).pipe(
        catchError((err) => {

            // 🔐 Handle session expired
            if (
                err.status === 401 &&
                err?.error?.message?.toLowerCase().includes('token') &&
                !isRedirecting
            ) {
                isRedirecting = true;

                localStorage.clear();

                toastService.error(
                    err?.error?.message || 'Your session has expired. Please login again.'
                );

                router.navigate(['/login']).then(() => {
                    isRedirecting = false;
                });
            }

            return throwError(() => err);
        })
    );
};